export function humanizeText(str: string): string {
    const humanized = str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z]{2,})([A-Z][a-z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        .replace(/E Doc/g, 'EDoc')
        .trim();
    // Capitalize first letter
    return humanized.charAt(0).toUpperCase() + humanized.slice(1);
}
